<template>
    <b-modal 
        size="lg" 
        no-close-on-backdrop 
        centered
        hide-footer
        title="Desbloquear Cliente"
        v-model="open"
    >
        <div class="d-block text-center mb-4">
          <h4>Tem certeza que deseja desbloquear a carteira do cliente</h4>
          <h5 v-if="user.client" class="mt-3 text-secondary">{{user.client.first_name}} {{user.client.last_name}}</h5>
          <h5 v-if="user.company" class="mt-3 text-secondary">{{user.company.nome_fantasia}}</h5>
          <h5 v-if="user.professional" class="mt-3 text-secondary">{{user.professional.name}}}</h5>
        </div>
        <div class="row d-block text-center">
            <button class="mt-3 btn btn-success" @click="unlock(user.id)">Desbloquear</button>
            <button class="mt-3 btn btn-danger ml-3" @click="open = false">Fechar</button>
        </div>
    </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import {mapActions } from 'vuex';

export default {
    name:'UnlockClient',
    emits:['getAllClient'],
    mixins: [makeToast],

    data() {
        return  {
            open: false,
            loading: false,
            user:[]
        }
    },

    methods: {
        ...mapActions('shopkeeper', [
            'updateWallet',
        ]),

        toggleOpen(user = []) {
            this.open = !this.open;
            this.user = user;
        },
        
        unlock(id){
            const data = {
                block: 0,
                id: id
            }
            this.$store.dispatch('startLoader');
            this.updateWallet(data)
            .then((response) => {
                this.makeToast(
                'Sucesso',
                'Cliente desbloqueado com sucesso',
                'success'
                );
                this.open = false
                this.$emit('getAllClient');
            })
            .catch(() => {
                this.makeToast(
                'Erro',
                'Houve um erro Atualizar os dados',
                'danger'
                );
            })
            .finally(() => {
                this.$store.dispatch('endLoader');
            });
    },
      
    }
}
</script>